
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="py-8 bg-cyber-black border-t border-cyber-green">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <div className="font-cyber text-lg text-shadow-glow">SpecialAgentK</div>
            <div className="text-xs font-cyber text-cyber-green-muted mt-1">// WACKY • VIGILANT • COVERT</div>
          </div>
          
          <div className="text-center md:text-right">
            <div className="font-cyber text-xs text-cyber-green-muted">
              <p>SYSTEM v1.0.3 // ENCRYPTION ENABLED</p>
              <p className="mt-1">&copy; {new Date().getFullYear()} SpecialAgentK // No rights reserved {">:')"}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
